// components/SectionList.tsx
import React from 'react';
import { Box, Stack, Divider, Text, Center } from '@mantine/core';
import { BuilderField, SectionGroup } from '../types/BuilderField';
import { FieldRow } from './FieldRow';

export interface SectionListProps {
  sections: SectionGroup[];
  readonly?: boolean;
  onEdit: (field: BuilderField) => void;
  onDelete: (field: BuilderField) => void;
  onMove: (field: BuilderField, dir: -1 | 1) => void;
}

export function SectionList({ sections, readonly, onEdit, onDelete, onMove }: SectionListProps) {
  if (sections.length === 0) {
    return (
      <Center py="xl">
        <Text c="dimmed" size="sm">
          No fields yet. Pick a field type from the left to get started.
        </Text>
      </Center>
    );
  }

  return (
    <Stack gap="lg">
      {sections.map((section) => (
        <Box key={section.category}>
          <Divider
            label={<Text fw={600} tt="uppercase" size="sm">{section.category}</Text>}
            labelPosition="center"
            mb="sm"
          />
          <Stack gap="sm">
            {section.rows.map((row) => (
              <FieldRow
                key={row.orderNo}
                row={row}
                readonly={readonly}
                onEdit={onEdit}
                onDelete={onDelete}
                onMove={onMove}
              />
            ))}
          </Stack>
        </Box>
      ))}
    </Stack>
  );
}